import React from "react";

const VideoCatalog = props => (
  <svg width="20" height="20" {...props}>
    <g fill="none" fillRule="evenodd" stroke="#027CC1">
      <rect
        width="18.5"
        height="18.5"
        x=".75"
        y=".75"
        strokeWidth="1.5"
        rx="2"
      />
      <g strokeLinecap="round">
        <path d="M4.5 5.63h11M4.5 8.63h11M4.5 11.63h11M4.5 14.63h11" />
      </g>
    </g>
  </svg>
);

export default VideoCatalog;
